import { call, delay, put, race, takeEvery } from 'redux-saga/effects';
import orytonServices from '../../../services/orytonServices';
import * as actions from '../../actions';
import * as actionTypes from '../../actionTypes/ActionTypes';
import { setDbTimezone } from '../../../services/timezone.service';
import { APIError } from '../../../constants/errorCode/system';

const FETCH_TIMEOUT = 30000;
const MAX_RETRIES = 4;

export default function* getCompaniesSaga() {
  yield takeEvery(actionTypes.COMPANY.GET_COMPANIES_REQUEST, handleGetCompanies);
}

// Worker saga
function* handleGetCompanies(action) {
  for (let attempt = 1; attempt <= MAX_RETRIES; attempt++) {
    try {
      const { result: userCompaniesResponse, timeout } = yield race({
        result: call(orytonServices.getCompanyByUser, action.payload),
        timeout: delay(FETCH_TIMEOUT),
      });

      const isConnectFail = timeout || userCompaniesResponse?.code === APIError.ConnectFail;
      if (isConnectFail) {
        if (attempt < MAX_RETRIES) {
          yield delay(5000);
          continue;
        }
        yield put(actions.getCompaniesFail('Request timeout'));
        return;
      }

      // set timezone immidiately
      if (userCompaniesResponse?.data?.timezone) {
        setDbTimezone(userCompaniesResponse.data.timezone);
      }

      const ownCompaniesResponse = yield call(orytonServices.getOwnCompanys);

      const { success, data, message } = userCompaniesResponse;

      if (!success) {
        yield put(actions.getCompaniesFail(message));
        return;
      }

      const dataOwner = mapValidOwnCompanies(ownCompaniesResponse?.data);

      const result = {
        total: data.total,
        data: data.data,
        dataOwner,
      };

      yield put(actions.getCompaniesSuccess(result));
      return;
    } catch (error) {
      if (attempt < MAX_RETRIES) continue;
      yield put(actions.getCompaniesFail(error));
    }
  }
}

// Helper function
const mapValidOwnCompanies = (companies = []) =>
  companies
    .filter((c) => ([undefined, null].includes(c.SubscriptionId) || c.Status === 0) && c.IsSpecial !== 1)
    .map((c) => ({ ...c, CompanyId: c.Id, isOwner: true }));
